module.exports = __webpack_public_path__ + "static/media/our-story.08058559.jpeg";


//////////////////
// WEBPACK FOOTER
// ./src/media/our-story.jpeg
// module id = 803
// module chunks = 0